import { MenuItem } from 'src/app/models/menu-item';

export const MENU: MenuItem[] = [
  {
    title: 'menu.dashboard',
    route: '/public/dashboard',
    icon: '',
    svgIcon: 'dashboard',
    child: [],
    permissions: []
  },
  {
    title: 'TVET MIS',
    route: '',
    icon: '',
    svgIcon: 'report',
    child: [
      {
        title: 'student.amount',
        route: ['/public/report/student/all'],
        icon: '',
        svgIcon: 'report',
        permissions: []
      },
      {
        title: 'program.short_course',
        route: ['/public/report/student/short-course'],
        icon: '',
        svgIcon: 'report',
        permissions: []
      },
      {
        title: 'program.long_course',
        route: ['/public/report/student/long-course'],
        icon: '',
        svgIcon: 'report',
        permissions: []
      },
      {
        title: 'staff.list',
        route: ['/public/report/staff'],
        icon: '',
        svgIcon: 'staff',
        permissions: []
      },
      {
        title: 'development.name',
        route: ['/public/report/development'],
        icon: '',
        svgIcon: 'staff',
        permissions: []
      }
    ],
    permissions: []
  },
  {
    title: 'TVET 1.5M',
    route: '',
    icon: '',
    svgIcon: 'report',
    child: [
      {
        title: 'student.amount',
        route: ['/public/report-s15/student/all'],
        icon: '',
        svgIcon: 'report',
        permissions: []
      },
      {
        title: 'គ្រិះស្ថាន',
        route: ['/public/report-s15/student/school'],
        icon: '',
        svgIcon: 'report',
        permissions: []
      },
      {
        title: 'ជំនាញ',
        route: ['/public/report-s15/student/skill'],
        icon: '',
        svgIcon: 'report',
        permissions: []
      }
    ],
    permissions: []
  }

  // {
  //    title: 'staff.name',
  //    route: 'staffs',
  //    icon: '',
  //    svgIcon: 'staff-alt',
  //    permissions: [],
  //    child: [
  //      {
  //        title: 'staff.list',
  //        route: ['/public/staff'],
  //        icon: '',
  //        svgIcon: 'listing',
  //        permissions: []
  //      },
  //      {
  //        title: 'development.name',
  //        route: ['/public/staff/development'],
  //        icon: '',
  //        svgIcon: 'feedback',
  //        permissions: []
  //      },

  //    ]
  //  },
  //    {
  //   title: 'report.name',
  //   route: 'report',
  //   icon: '',
  //   svgIcon: 'report',
  //   permissions: [],
  //   child: []
  //   // child: [
  //   //   {
  //   //     title: 'staff.list',
  //   //     route: ['/private/staff'],
  //   //     icon: '',
  //   //     svgIcon: 'listing',
  //   //     permissions: []
  //   //   },
  //   //   {
  //   //     title: 'development.name',
  //   //     route: ['/private/staff/development'],
  //   //     icon: '',
  //   //     svgIcon: 'feedback',
  //   //     permissions: []
  //   //   },

  //   // ]
  // },
];
